<template>
  <div class="macaoPage" style="margin-top:220px;">
    <div class="a_jc" v-html="aomenList.content"></div>
    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
  </div>
</template>

<script>
  import Nav from '@/components/Nav'
  //api
  import {articlesList  ,articlesDetails ,articleCats } from '@/api/article';
  //common.js
  import {setLocalStorage, getLocalStorage} from '@/utils/common';
export default {
  name: 'MacaoPage',
  components:{
     Nav
  },
  data () {
    return {
      tipsState:false,
      navState:true,
      titles: '',
      titleChild:[{name:'',src:''}],
      /*二级导航id*/
      articleId:this.$route.query.id,
//      jiId:this.$route.query.jiId,
//      tip:this.$route.query.tip,
      aomenList:{}
    }
  },
  methods:{
    /*获取所有列表*/
    getAllLists(){
//      allLists().then(res =>{
//        this.macaoList = res.data.data[3];
//        this.jiId = res.data.data[3].id;
        //请求澳门极草
       /* var obj = {
          include:'articlecat',
          article:this.jiId
        }*/
//       this.jiId = 4
//      articleCats({parent_id:4},undefined).then(res =>{
//          this.aomenList = res.data.data[0];
//          this.titles = res.data.data[0].name;

        articlesDetails(5).then(res =>{
          this.aomenList = res.data;
          this.titles = res.data.title;
        })

//        })
//      })
    },
    jicao(articleId){
       /* this.aomenList = JSON.parse(sessionStorage.getItem('maCao'));
        this.titles = this.aomenList.title*/
      if(articleId){
        articlesDetails(articleId).then(res =>{
          this.aomenList = res.data;
          this.titles = res.data.title;
        })
      }
    }
  },
  created(){
    this.jicao(this.articleId)
    window.scrollTo(0,0)
  },
//  beforeRouteUpdate (to, from, next) {
//      console.log(to, from)
//    this.jicao(to.query.id)
//    next()
//  }
  watch : {
    '$route' (to, from) {
        console.log(to, from)
      this.jicao(to.query.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/MacaoPage.vue